var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"the-blank",class:{'blank-sp': _vm.$store.state.screen == 1}},[_c('img',{attrs:{"src":require("images/blank.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }